<div id="share-schedule-button" class="u_clickable" (click)="openMenu()">
  <a
    rv-button
    variant="secondary"
    class="hidden-xs"
    [ngClass]="buttonClass"
    [matMenuTriggerFor]="shareMenu"
  >
    Share
  </a>
</div>
<mat-menu
  #shareMenu="matMenu"
  xPosition="before"
  class="share-panel"
  panelClass="share-panel"
>
  <shared-schedule-popover
    #sharePopover
    (dismissEvent)="dismiss()"
  ></shared-schedule-popover>
</mat-menu>

<button
  rv-button
  variant="secondary"
  id="actionSheetButton"
  type="button"
  class="visible-xs-inline"
  [ngClass]="buttonClass"
  (click)="openActionSheet()"
>
  Share
</button>
